import type {} from 'dayjs';
import { dayjs } from '../../shared/utils/date';
import { Account } from './account';

export namespace ImmutableEntity {
  export type Props = {
    createdById: string;
    createdAt: string | Date | dayjs;
  };
  export const Construct = (props: Props): ImmutableEntity => {
    return {
      createdById: Account.Id.FromString(props.createdById),
      createdAt: dayjs(props.createdAt),
    };
  };
  export const Create = (params: { date?: dayjs; operatorId: Account.Id }): ImmutableEntity => {
    const { date = dayjs(new Date()), operatorId } = params;
    return {
      createdById: operatorId,
      createdAt: date,
    };
  };
}
export type ImmutableEntity = {
  createdById: Account.Id;
  createdAt: dayjs;
};

export namespace MutableEntity {
  export type Props = {
    createdById: string;
    createdAt: string | Date | dayjs;
    updatedById: string;
    updatedAt: string | Date | dayjs;
  };
  export const Construct = (props: Props): MutableEntity => {
    return {
      createdById: Account.Id.FromString(props.createdById),
      createdAt: dayjs(props.createdAt),
      updatedById: Account.Id.FromString(props.updatedById),
      updatedAt: dayjs(props.updatedAt),
    };
  };
  export const Create = (params: { date?: dayjs; operatorId: Account.Id }): MutableEntity => {
    const { date = dayjs(new Date()), operatorId } = params;
    return {
      createdById: operatorId,
      createdAt: date,
      updatedById: operatorId,
      updatedAt: date,
    };
  };
  export const Update = ({
    date = dayjs(new Date()),
    cur,
    operatorId,
  }: {
    date?: dayjs;
    cur: MutableEntity;
    operatorId: Account.Id;
  }): MutableEntity => {
    return {
      createdById: cur.createdById,
      createdAt: cur.createdAt,
      updatedById: operatorId,
      updatedAt: date,
    };
  };
}
export type MutableEntity = {
  createdById: Account.Id;
  createdAt: dayjs;
  updatedById: Account.Id;
  updatedAt: dayjs;
};
